import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import LogInlineLink from '#component/general/log-inline-link';
import { userEventType } from '#type';

const EventDescription = ({ log }) => {
  const { actor, event: { id }, user } = log;
  const {
    CREATE_USER,
    EDIT_USER,
    ENABLE_USER,
    DISABLE_USER,
    LOGIN,
    LOGIN_FAILED,
    SET_PASSWORD,
    RESET_PASSWORD,
    CREATE_APIKEY,
    DELETE_APIKEY
  } = userEventType;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const userFirstAndLastName = (
    <>
      &nbsp;
      <LogInlineLink to={`/user/${user.id}`} text={`${user?.firstName} ${user?.lastName}`} isMobile={isMobile} />
      &nbsp;
    </>
  );

  try {
    switch (id) {
      case CREATE_USER:
        return (
          <>
            User
            {userFirstAndLastName}
            was created
          </>
        );
      case EDIT_USER:
        return actor.id === user.id ? (
          <>
            User
            {userFirstAndLastName}
            profile was edited
          </>
        ) : (
          <>
            User
            {userFirstAndLastName}
            was edited
          </>
        );
      case ENABLE_USER:
        return (
          <>
            User
            {userFirstAndLastName}
            was enabled
          </>
        );
      case DISABLE_USER:
        return (
          <>
            User
            {userFirstAndLastName}
            was disabled
          </>
        );
      case LOGIN:
        return (
          <>
            {userFirstAndLastName}
            logged in
          </>
        );
      case LOGIN_FAILED:
        return (
          <>
            {userFirstAndLastName}
            failed to login
          </>
        );
      case SET_PASSWORD:
        return (
          <>
            {userFirstAndLastName}
            created password
          </>
        );
      case RESET_PASSWORD:
        return (
          <>
            {userFirstAndLastName}
            restored password
          </>
        );
      case CREATE_APIKEY:
        return (
          <>
            {userFirstAndLastName}
            created API key
          </>
        );
      case DELETE_APIKEY:
        return (
          <>
            {userFirstAndLastName}
            deleted API key
          </>
        );
      default:
        return 'Not recognized event';
    }
  } catch (e) {
    return 'Not recognized event';
  }
};

export default EventDescription;
